import i18n from '@medflex/i18n';
import { initReactI18next } from 'react-i18next';

export default options =>
  i18n({
    plugins: [initReactI18next],
    ...options,
    interpolation: { escapeValue: false },
  });
